import { MantineThemeOverride } from '@mantine/core';

export type NotificationTheme = NonNullable<MantineThemeOverride['components']>['Notification'];

export const Notification: NotificationTheme = {
  // todo: define
};
